"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplate = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let NotificationTemplate = class NotificationTemplate {
};
exports.NotificationTemplate = NotificationTemplate;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationTemplate.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], NotificationTemplate.prototype, "subject", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)('text'),
    tslib_1.__metadata("design:type", String)
], NotificationTemplate.prototype, "body", void 0);
exports.NotificationTemplate = NotificationTemplate = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_template')
], NotificationTemplate);
